import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { AnalogInput, CalibrationTable, RadioSensor } from 'z3k-config';
import { sensor_defaults_on_create } from './constant';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { unpack_validation } from 'z3k-parser/validation/types';
import { useBox } from 'shared/hooks/utils';
import { ShowAnalogInputValue } from './show-value';
import { analog_inputs_state_selector } from '../utils/z3k-state';
import { Z3KSettings, Z3KSettingsEditor, Z3KSettingsState, } from 'console/device-settings/z3k/provider/types';
import { Divider } from '@mui/material';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { NewRadioSensors433ClickList } from '../radio/radiosensors/433/components/list';
import { RadioSensorsClickList } from '../radio/radiosensors/868/components/list';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
export function AnalogInputsList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { z3k_state } = useContext(Z3KSettingsState);
    const { addIdToBlacklist } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const onDeleteSensor = useCallback((object, new_list) => {
        addIdToBlacklist(object.id);
        if (object.calibration) {
            addIdToBlacklist(object.calibration);
            replace_config({
                ...findAndChangeLinks(CalibrationTable.get.removeById(configBox.current, object.calibration), object.id),
                analog_inputs: new_list,
            });
        }
        else {
            replace_config({
                ...findAndChangeLinks(configBox.current, object.id),
                analog_inputs: new_list,
            });
        }
    }, [addIdToBlacklist, replace_config]);
    const onAddClick = useCallback(() => {
        const [ct_id, new_config] = CalibrationTable.get.add(configBox.current, {
            table: [],
            multiply_x: 10,
        });
        replace_config(AnalogInput.get.add(new_config, {
            name: 'Датчик',
            notification_list: [],
            upper_notification_list: [],
            physical_input_num: -1,
            sensor_type: sensor_defaults_on_create.sensor_type,
            recovery_list: [],
            ...sensor_defaults_on_create.defaults,
            is_new: true,
            impulse_frequency: 1,
            calibration: ct_id,
            units: 0,
            position: 0,
        })[1]);
    }, [replace_config]);
    const analog_inputs_state = analog_inputs_state_selector(config, z3k_state);
    const titleComponentRender = useCallback((ai) => (_jsx(ShowAnalogInputValue, { state: analog_inputs_state?.[ai.id], analog_input: ai })), [analog_inputs_state]);
    const filterRadiosensors = useCallback((rs) => !RadioSensor.isFobButtons(rs) &&
        !RadioSensor.isRelaySensor(rs) &&
        !RadioSensor.isThermometer(rs), []);
    const childrenItem = (selected_item_id) => {
        return (_jsxs(_Fragment, { children: [_jsx(DragDropDrawer, { z3k_name: "analog_inputs", name: RouteNaming[Z3kSecondRoutes.analog_inputs], help_id: "analog_inputs", enableDnd: true, item_url: Z3kSecondRoutes.analog_inputs, titleComponentRender: titleComponentRender, onAddClick: onAddClick, onDelete: onDeleteSensor, selected_item_id: selected_item_id }), _jsx(Divider, {}), _jsx(RadioSensorsClickList, { name: RouteNaming[Z3kSecondRoutes.radiosensor868], objectFilter: filterRadiosensors, help_id: "radiosensors_in_analog_inputs" }), _jsx(Divider, {}), _jsx(NewRadioSensors433ClickList, { name: RouteNaming[Z3kSecondRoutes.radiosensor433], help_id: "radiosensors_in_analog_inputs" })] }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
AnalogInputsList.isError = (validation_result) => {
    return !!unpack_validation(validation_result, 'analog_inputs');
};
AnalogInputsList.isWarning = AnalogInputsList.isError;
AnalogInputsList.isShown = (is_service_view, config, { show_settings }, is_staff, is_climatic) => show_settings.show_AnalogInputsPage && !is_climatic;
